import MuiAlert, { type AlertProps, alertClasses } from '@mui/material/Alert';
import { alertTitleClasses } from '@mui/material/AlertTitle';
import { type SxProps, type Theme } from '@mui/material/styles';

type Props = Omit<AlertProps, 'color' | 'variant'> & {
  size?: 'medium' | 'small';
  wiggle?: boolean;
};

const compactSx: SxProps<Theme> = {
  fontSize: '14px',
  lineHeight: 1.4,
  padding: '4px 12px',
  [`& .${alertClasses.icon}`]: {
    fontSize: '20px',
    marginRight: 1,
    padding: '2px 0',
  },
  [`& .${alertClasses.message}`]: {
    padding: '2px 0',
  },
  [`& .${alertClasses.action}`]: {
    padding: 0,
  },
  [`& .${alertTitleClasses.root}`]: {
    fontSize: '14px',
    lineHeight: 1.4,
    marginBottom: 0.25,
  },
};

export const Alert = ({ size = 'medium', sx, wiggle, ...rest }: Props) => {
  return (
    <MuiAlert
      sx={[
        ({ animations }) =>
          wiggle
            ? {
                animation: `${animations.wiggle} .5s ease-in-out`,
                animationDelay: '300ms',
              }
            : {},
        ...(size === 'small' ? [compactSx] : []),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    />
  );
};
